import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const ArrowContainer = styled.div({
  paddingTop: 24,
  [mobileMediaQuery]: {
    paddingTop: 0,
  },
});
